<template>
    <ValidationObserver v-slot="{ handleSubmit }" v-if="campaign">
        <form @submit.prevent="handleSubmit(onSubmit)">
            <div class="p-5">
                <div
                    class="d-flex justify-content-between align-items-center mb-4"
                >
                    <div class="c-title">
                        Campaign - {{ campaign.type_name }}
                    </div>

                    <div class="ml-auto">
                        <div class="dropdown-btn">
                            <a
                                @click="() => {
                                        if (DibbleJS.isAllowedAccess(Authorizations.MODULE_NAMES.CAMPAIGN_VIEW_CHANGE_STATUS)) {
                                            toggleActiveButton = !toggleActiveButton
                                        }
                                    }
                                "
                                class="btn c-cancel-btn d-flex flex-column align-items-center"
                            >
                                <span class="top">Status</span>
                                <span
                                    :style="
                                        'color: ' + campaignStatusTextColor + ''
                                    "
                                    v-text="campaignStatusText"
                                ></span>
                            </a>
                            <div
                                v-if="toggleActiveButton"
                                class="dropdown-menu"
                                :class="toggleActiveButton ? 'active' : ''"
                                v-click-outside="
                                    () => {
                                        toggleActiveButton = false;
                                    }
                                "
                            >
                                <a
                                    class="dropdown-item"
                                    :style="'color: ' + status.color + ''"
                                    href="javascript:;"
                                    v-for="(status, index) in campaign.statuses"
                                    :key="index"
                                    @click="handleChangeTab(index)"
                                    v-text="status.name"
                                ></a>
                            </div>
                        </div>
                    </div>
                    <div class="ml-3">
                        <!--                        <a href="javascript:;" class="btn c-distribution-btn" @click="showDistributionModal">Distribute</a>-->
                        <div class="dropdown-btn">
                            <a
                                @click="
                                    toggleActionButton = !toggleActionButton
                                "
                                class="btn c-save-btn d-flex flex-column align-items-center"
                            >
                                <span
                                    class="text-white"
                                    v-text="'Actions'"
                                ></span>
                            </a>
                            <div
                                v-if="toggleActionButton"
                                class="dropdown-menu"
                                :class="toggleActionButton ? 'active' : ''"
                                v-click-outside="
                                    () => {
                                        toggleActionButton = false;
                                    }
                                "
                            >
                                <button v-if="DibbleJS.isAllowedAccess(Authorizations.MODULE_NAMES.CAMPAIGN_EDIT)"
                                    class="dropdown-item"
                                    type="submit"
                                    v-text="'Edit'"
                                ></button>
                                <a
                                    v-if="DibbleJS.isAllowedAccess(Authorizations.MODULE_NAMES.CAMPAIGN_DONATIONS)"
                                    class="dropdown-item"
                                    href="javascript:;"
                                    @click="goToDonations"
                                    v-text="'Donations'"
                                ></a>
                                <a
                                    v-if="DibbleJS.isAllowedAccess(Authorizations.MODULE_NAMES.CAMPAIGN_DESIGNATION)"
                                    class="dropdown-item"
                                    href="javascript:;"
                                    @click="goToDesignations"
                                    v-text="'Designations'"
                                ></a>
                                <a
                                    v-if="DibbleJS.isAllowedAccess(Authorizations.MODULE_NAMES.CAMPAIGN_DISTRIBUTION)"
                                    class="dropdown-item"
                                    @click="
                                        toggleActionButton = false;
                                        goToDistributions();
                                    "
                                    href="javascript:;"
                                    v-text="'Distributions'"
                                ></a>
                                <a
                                    v-if="DibbleJS.isAllowedAccess(Authorizations.MODULE_NAMES.CAMPAIGN_QUESTION)"
                                    class="dropdown-item"
                                    @click="
                                        toggleActionButton = false;
                                        goToQuestions();
                                    "
                                    href="javascript:;"
                                    v-text="'Questions'"
                                ></a>
                                <a
                                    v-if="campaign.status === 2 && DibbleJS.isAllowedAccess(Authorizations.MODULE_NAMES.CAMPAIGN_ADD_MANUAL_DONATION)"
                                    class="dropdown-item"
                                    @click="isOpenManualDonateModal = true"
                                    href="javascript:;"
                                    v-text="'Manual Donation'"
                                ></a>
                            </div>
                        </div>
                    </div>
                    <RouterLink class="ml-3" to="/campaigns">
                        <button class="btn c-cancel-btn">Back</button>
                    </RouterLink>
                </div>

                <div class="row">
                    <div class="col-12">
                        <div class="text-secondary mb-5">
                            <span style="font-size: 18px">{{
                                campaign.title
                            }}</span>
                        </div>
                        <div class="mb-2" v-if="campaign.type === 3">
                            <span class="text-secondary"
                                >Link to Event Management:
                            </span>
                            <a
                                :href="campaign.event_manager_url"
                                target="_blank"
                                style="color: #41b8dc"
                                >{{ campaign.event_manager_url }}</a
                            >
                            <a href="javascript:;">
                                <img
                                    src="@/assets/images/copy.svg"
                                    class="ml-2"
                                    @click="
                                        copyToClipboard(
                                            campaign.event_manager_url
                                        )
                                    "
                                />
                            </a>
                        </div>
                        <div class="mb-2">
                            <span class="text-secondary"
                                >Link to donation page:
                            </span>
                            <a
                                :href="campaign.donation_page_url"
                                target="_blank"
                                style="color: #41b8dc"
                                >{{ campaign.donation_page_url }}</a
                            >
                            <a href="javascript:;">
                                <img
                                    src="@/assets/images/copy.svg"
                                    class="ml-2"
                                    @click="
                                        copyToClipboard(
                                            campaign.donation_page_url
                                        )
                                    "
                                />
                            </a>
                        </div>
                        <div class="mb-2">
                            <span class="text-secondary">Link to wall: </span>
                            <a
                                :href="campaign.wall_page_url"
                                style="color: #41b8dc"
                                target="_blank"
                                >{{ campaign.wall_page_url }}</a
                            >
                            <a href="javascript:;">
                                <img
                                    src="@/assets/images/copy.svg"
                                    class="ml-2"
                                    @click="
                                        copyToClipboard(campaign.wall_page_url)
                                    "
                                />
                            </a>
                        </div>
                        <div class="mb-5 row">
                            <div class="col-7">
                                <span class="text-secondary"
                                    >Download QR code:
                                </span>
                                <span>
                                    <a
                                        style="color: #41b8dc"
                                        :href="campaign.qr_code_url.small"
                                        target="_blank"
                                        >Small</a
                                    >
                                    /
                                    <a
                                        style="color: #41b8dc"
                                        :href="campaign.qr_code_url.large"
                                        target="_blank"
                                        >Large</a
                                    >
                                </span>
                            </div>
                            <div class="col-5">
                                <div class="mb-1 text-secondary">
                                    Javascript Code:
                                </div>
                                <TextField
                                    v-model="campaignJsCode"
                                    name="htmlCode"
                                    readonly
                                    class-wrapper="html-code"
                                >
                                    <template #append-icon>
                                        <a href="javascript:;" @click="() => {
                                                    copyToClipboard(campaignJsCode);
                                                }">
                                            <img
                                                src="~@/assets/images/copy.svg"
                                            />
                                        </a>
                                    </template>
                                </TextField>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-7">
                        <div v-if="parseInt(form.type) === 3">
                            <div class="row">
                                <div class="col-md-4">
                                    <DatePickerField
                                        v-model="form.start_date"
                                        name="start_date"
                                        label="Start Date"
                                        rules="required"
                                        readonly
                                    />
                                </div>
                                <div class="col-md-4">
                                    <TimePickerField
                                        v-model="form.start_time"
                                        :value="form.start_time"
                                        name="start_time"
                                        label="Start Time"
                                        rules="required"
                                        readonly
                                    />
                                </div>
                                <div class="col-md-4">
                                    <TextField
                                        v-if="timezones.length > 0"
                                        :value="timezones.find(timezone => timezone.value === form.timezone).label"
                                        name="timezone"
                                        label="Time Zone"
                                        :options="timezones"
                                        :has-icon="true"
                                        readonly
                                    />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    <DatePickerField
                                        v-model="form.end_date"
                                        name="start_date"
                                        label="Start Date"
                                        rules="required"
                                        readonly
                                    />
                                </div>
                                <div class="col-md-4">
                                    <TimePickerField
                                        v-model="form.end_time"
                                        name="end_time"
                                        label="End Time"
                                        rules="required"
                                        readonly
                                    />
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <DatePickerField
                                v-model="form.start_date"
                                name="start_date"
                                label="Start Date"
                                rules="required"
                                readonly
                            />
                            <DatePickerField
                                v-model="form.end_date"
                                name="end_date"
                                label="End Date"
                                :disabled="disabledEndDate"
                                readonly
                            />
                        </div>

                        <TextareaField
                            v-model="form.about_short"
                            name="about_short"
                            label="About the Campaign - Short Description"
                            rules="required"
                            rows="5"
                            classWrapper="mb-4"
                        />
                        <TextareaField
                            v-model="form.about_campaign"
                            name="about_campaign"
                            label="Full Description"
                            rules="required"
                            rows="5"
                            classWrapper="mb-4"
                            readonly
                        />
                        <TextareaField
                            v-model="form.thankyou"
                            name="thankyou"
                            label="Thank You Note"
                            rules="required"
                            rows="5"
                            classWrapper="mb-4"
                            readonly
                        />
                    </div>

                    <div class="col-5">
                        <TextField
                            v-if="form.designations"
                            v-model="form.designations"
                            name="designations"
                            label="Designations"
                            readonly
                        />
                        <TextField
                            v-model="form.goal_amount"
                            name="goal_amount"
                            label="Goal Amount"
                            readonly
                        />
                        <TextField
                            v-model="form.slam_amount"
                            name="slam_amount"
                            label="Slam Amount"
                            readonly
                        />

                        <div class="c-label">Amount Options</div>
                        <div class="row">
                            <div
                                class="col-6"
                                v-for="(option, index) in form.amount_options"
                                :key="index"
                            >
                                <TextField
                                    v-model="form.amount_options[index]"
                                    :name="`amount_options[${index}]`"
                                    :label="`Option ${index + 1}`"
                                    rules="required"
                                    readonly
                                />
                            </div>
                        </div>

                        <div class="c-label">Images</div>
                        <div class="c-upload">
                            <UploadImage
                                v-for="(image, index) in form.images"
                                :key="index"
                                v-model="form.images[index]"
                                :name="`images[${index}]`"
                                :view-mode="true"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </form>

        <modal-campaign-manual-donation
            v-if="isOpenManualDonateModal"
            :data="campaign"
            @close="isOpenManualDonateModal = false" />
    </ValidationObserver>
</template>

<script>
import TextField from '@/commons/FormElements/TextField.vue';
import TextareaField from '@/commons/FormElements/TextareaField.vue';
import DatePickerField from '@/commons/FormElements/DatePickerField.vue';
import UploadImage from '@/commons/FormElements/UploadImage.vue';
import { TYPE_IDS, TAB_IDS } from './constants/index';
import DibbleJs from '@/dibble';
import DibbleApi from '@/api';
import DibbleAPI from '@/api';
import DibbleJS from "@/dibble";
import Authorizations from "@/utils/authorizations";
import ModalCampaignManualDonation
    from "@/components/campaigns/components/ModalCampaignManualDonation.vue";
import TimePickerField from "@/commons/FormElements/TimePickerField.vue";

export default {
    name: 'EditView',
    components: {
        TimePickerField,
        ModalCampaignManualDonation,
        TextField,
        TextareaField,
        UploadImage,
        DatePickerField,
    },
    data() {
        return {
            isOpenManualDonateModal: false,
            toggleActiveButton: false,
            toggleActionButton: false,
            campaignJsCode: "giveriseOpenDonationBox('" +  this.$route.params.id + "')",
            form: {
                type: '',
                start_date: '',
                start_time: '',
                end_date: '',
                end_time: '',
                timezone: '',
                about_short: '',
                about_campaign: '',
                thankyou: '',
                goal_amount: '',
                amount_options: ['', '', '', '', '', ''],
                slam_amount: '',
                images: ['', '', ''],
                designations: '',
            },
            types: [
                { value: TYPE_IDS.ON_GOING, label: 'On Going' },
                { value: TYPE_IDS.TIME_SPANNED, label: 'Time Spanned' },
                { value: TYPE_IDS.EVENT, label: 'Event' },
            ],
            tabs: [
                { value: TAB_IDS.ACTIVE, label: 'Active' },
                { value: TAB_IDS.INACTIVE, label: 'Inactive' },
                { value: TAB_IDS.COMPLETED, label: 'Completed' },
            ],
            timezones: [],
            activeTab: 0,
            campaign: null,
            distributionData: null,
            isShowModalDistribution: false,
            isShowModalDistributionErrored: false,
            isShowModalDistributionSuccess: false,
            isShowModalDistributionProgress: false,
        };
    },
    computed: {
        Authorizations() {
            return Authorizations
        },
        DibbleJS() {
            return DibbleJS
        },
        disabledEndDate() {
            return this.form.type === TYPE_IDS.ON_GOING;
        },
        campaignStatusText() {
            return this.campaign.statuses[this.activeTab].name;
        },
        campaignStatusTextColor() {
            return this.campaign.statuses[this.activeTab].color;
        },
    },
    methods: {
        onSubmit() {
            this.$router.push({
                name: 'CampaignEdit',
                params: {
                    id: this.$route.params.id,
                },
            });
        },
        goToDonations() {
            this.$router.push({
                name: 'CampaignDonations',
                params: {
                    id: this.$route.params.id,
                },
            });
        },
        goToDistributions() {
            this.$router.push({
                name: 'CampaignDistributions',
                params: {
                    id: this.$route.params.id,
                },
            });
        },
        goToQuestions() {
            this.$router.push({
                name: 'CampaignQuestions',
                params: {
                    id: this.$route.params.id,
                },
            });
        },
        goToDesignations() {
            this.$router.push({
                name: 'CampaignDesignations',
                params: {
                    id: this.$route.params.id,
                },
            });
        },
        getCampaign() {
            DibbleJs.showLoader();
            const data = {
                '#request': DibbleApi.api.getCampaign,
                campaign_id: this.$route.params.id,
            };
            DibbleJs.callApiRequest(data, (response) => {
                if (DibbleApi.isResponseSuccess(response)) {
                    this.campaign = response;
                    this.form = {
                        type: response.type,
                        start_date: this.$moment(response.start_date).format(
                            'MM/DD/YYYY'
                        ),
                        start_time: response.event_start_time,
                        end_date: response.end_date
                            ? this.$moment(response.end_date).format(
                                  'MM/DD/YYYY'
                              )
                            : '',
                        end_time: response.event_end_time,
                        timezone: response.event_time_zone,
                        about_short: response.about_short,
                        about_campaign: response.about_campaign,
                        thankyou: response.thankyou,
                        goal_amount: this.numberToCurrency(
                            response.goal_amount.toString()
                        ),
                        amount_options: response.amount_options.map((item) =>
                            this.numberToCurrency(item.toString())
                        ),
                        slam_amount: this.numberToCurrency(
                            response.slam_amount.toString()
                        ),
                        images: response.images,
                    };

                    if (response.designations.length > 0) {
                        this.form.designations = response.designations[0].name;

                        if (response.designations.length > 1) {
                            this.form.designations += `, + ${
                                response.designations.length - 1
                            } more`;
                        }
                    }

                    this.activeTab = response.status;
                } else {
                    DibbleJs.toastErrorMessage(response.message);
                }
                DibbleJs.hideLoader();
            });
        },
        handleChangeTab(tabIndex) {
            this.toggleActiveButton = false;
            DibbleJS.showLoader();
            const params = {
                '#request': DibbleAPI.api.campaignSetStatus,
                campaign_id: this.campaign.campaign_id,
                status: tabIndex,
            };
            DibbleJS.callApiRequest(params, (responseData) => {
                DibbleJS.hideLoader();
                if (DibbleAPI.isResponseSuccess(responseData)) {
                    this.activeTab = tabIndex;
                } else {
                    DibbleJS.toastErrorMessage(responseData.message);
                }
            });
        },
        numberToCurrency(x) {
            return '$' + x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        copyToClipboard(text) {
            const el = document.createElement('textarea');
            el.value = text;
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
            DibbleJs.toastSuccessMessage(
                'The link was copied to the clipboard'
            );
        },
        getTimezoneList() {
            const params = {
                '#request': DibbleApi.api.getTimezoneList,
            }
            DibbleJs.callApiRequest(params, (response) => {
                if (DibbleApi.isResponseSuccess(response)) {
                    for (const timezone in response.time_zones) {
                        this.timezones.push({
                            value: timezone,
                            label: response.time_zones[timezone],
                        })
                    }
                } else {
                    DibbleJs.toastErrorMessage(response.message);
                }
            })
        },
    },
    created() {
        this.getCampaign();
        this.getTimezoneList();
    },
};
</script>

<style lang="scss" scoped>
.c-title {
    color: #2178ab;
    font-size: 22px;
    font-weight: 700;
}

.c-cancel-btn {
    border-radius: 20px;
    background: #d9d9d9;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
    font-size: 20px;
    font-weight: 700;
    width: 120px;
    color: #555e67;
    line-height: 140%;
}

.c-donations-btn,
.c-distribution-btn {
    border-radius: 20px;
    background: #6ca779;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
    font-size: 20px;
    font-weight: 700;
    width: 140px;
    color: #fff;
    line-height: 140%;
}

.c-distribution-btn {
    background: #7bbdef;
    color: #555e67 !important;
    width: 160px;
}

.c-save-btn {
    border-radius: 20px;
    background: #2178ab;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
    font-size: 20px;
    font-weight: 700;
    color: #fff;
    width: 120px;
    line-height: 140%;
}

.c-label {
    font-size: 20px;
    line-height: 24px;
    color: #555e67;
    margin-top: 33px;
    margin-bottom: 33px;
}

.c-upload {
    background-color: #e1e7e9;
    border-radius: 20px;
    padding: 24px 32px;
}

.c-tab-list {
    border-radius: 20px;
    overflow: hidden;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
    margin-bottom: 28px;
}

.dropdown-btn {
    position: relative;

    span {
        display: block;

        &.top {
            font-size: 12px;
            line-height: 16px;
            color: #555e67;
            position: absolute;
            top: -1px;
        }
    }

    .dropdown-menu {
        position: absolute;
        top: 100%;
        left: 0;
        z-index: 1000;
        display: none;
        min-width: 10rem;
        text-align: left;
        list-style: none;

        background-clip: padding-box;
        border: none;
        border-radius: 30px;
        width: 275px;
        background: none;

        &.active {
            display: block;
        }

        .dropdown-item {
            color: #555e67;
            font-size: 20px;
            font-weight: 700;
            background-color: #edf5f7;
            padding: 12px 35px;
            border-bottom: 1px solid #dee6ea;

            &:first-child {
                border-top-left-radius: 20px;
                border-top-right-radius: 20px;
            }

            &:last-child {
                border-bottom-left-radius: 30px;
                border-bottom-right-radius: 30px;
                box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
            }

            &:hover {
                background-color: #bae3ef;
                color: #2178ab;
            }
        }
    }
}
</style>
